import { useTheme } from '@mui/material';

export const IntroIcon6 = ({ className }: { className: string }) => {
    const theme = useTheme();
    const {
        stroke: { primary: primaryStroke },
    } = theme.colors.other.icon;

    return (
        <svg
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="18"
            viewBox="0 0 24 18"
            fill="none"
        >
            <path
                d="M3 2.25488C2.5875 2.25488 2.25 2.59238 2.25 3.00488V4.04082L10.3359 10.6783C11.3062 11.4752 12.6984 11.4752 13.6688 10.6783L21.75 4.04082V3.00488C21.75 2.59238 21.4125 2.25488 21 2.25488H3ZM2.25 6.95176V15.0049C2.25 15.4174 2.5875 15.7549 3 15.7549H21C21.4125 15.7549 21.75 15.4174 21.75 15.0049V6.95176L15.0938 12.4174C13.2937 13.8939 10.7016 13.8939 8.90625 12.4174L2.25 6.95176ZM0 3.00488C0 1.3502 1.34531 0.00488281 3 0.00488281H21C22.6547 0.00488281 24 1.3502 24 3.00488V15.0049C24 16.6596 22.6547 18.0049 21 18.0049H3C1.34531 18.0049 0 16.6596 0 15.0049V3.00488Z"
                fill={primaryStroke}
            />
        </svg>
    );
};
